import {orderDateStyles} from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import upperCase from "lodash/upperCase";
import { css } from "styled-components";

orderDateStyles.titleText = {
    variant: "h3",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: 15px !important;
    `,
    size: 15,
    transform: "uppercase",
}

orderDateStyles.orderDate = {
    size: 16,
}

orderDateStyles.wrapper = {
    css: css`
    padding-bottom: 0;
    ${({ theme }: { theme: BaseTheme }) =>
    breakpointMediaQueries(theme, [
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
            padding-bottom: 10px;
        `,
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
            padding-bottom: 10px;
        `,
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
            padding-bottom: 10px;
        `,
        css`
        `,
        css`
        `,
    ])}`,
}